import React, { useState } from 'react'
import styled from 'styled-components'

export type ClipsPopUpProps = {
  enabled?: boolean
}

type BannerContainerProps = {
  opened?: boolean
}

const mobileQuery = '@media (max-width: 828px)'

const BannerContainer = styled.a<BannerContainerProps>`
  height: 60px;
  background: linear-gradient(90deg, #e646b6, #ff6666);
  display: ${({ opened }) => (opened ? 'flex' : 'none')};
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  ${mobileQuery} {
    height: 100px;
    justify-content: flex-start;
  }
`

const BannerText = styled.div`
  color: white;
  display: flex;
  vertical-align: middle;
  align-items: center;
  margin-right: 56px;

  ${mobileQuery} {
    flex-flow: column nowrap;
    margin-right: 0;
  }
`

const Bold = styled.span`
  font-weight: 800;
`

const Underline = styled(Bold)`
  text-decoration: underline;
`

const EmojiSpacer = styled.div`
  flex-grow: 0;
  ${mobileQuery} {
    flex-basis: 5%;
  }
`

const EmojiContainer = styled.div`
  display: flex;
  justify-content: center;
  ${mobileQuery} {
    height: 100%;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: center;
    align-self: flex-start;
    flex-basis: 20%;
  }
`

const Emoji = styled.div`
  background-image: url('https://media.giphy.com/media/S3nZ8V9uemShxiWX8g/giphy.gif');
  height: 40px;
  width: 40px;
  background-size: cover;
`

const BannerCloseButton = styled.div`
  position: absolute;
  right: 13px;
  top: 13px;
  width: 40px;
  height: 40px;
  opacity: 0.8;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
  &:before,
  &:after {
    position: absolute;
    left: 15px;
    content: ' ';
    height: 30px;
    width: 2px;
    background-color: #ffffff;
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
  ${mobileQuery} {
    top: 5px;
    right: 5px;
  }
`

const BannerEmoji = () => {
  return (
    <EmojiContainer>
      <EmojiSpacer />
      <Emoji />
    </EmojiContainer>
  )
}

export const ClipsPopUp = ({ enabled }: ClipsPopUpProps) => {
  const [isOpened, setOpened] = useState(enabled)

  return (
    <BannerContainer
      id="giphy-clips-banner"
      opened={isOpened}
      href="https://developers.giphy.com/docs/clips"
    >
      <BannerEmoji />
      <BannerText>
        <span>
          <Bold>GIPHY </Bold>
          <span>Clips (GIFs with Sound)&nbsp;</span>
        </span>
        <span>
          have arrived! Learn about adding Clips to your app{' '}
          <Underline>in our documentation!</Underline>
        </span>
      </BannerText>
      <BannerCloseButton
        onClick={(e) => {
          e.preventDefault()
          setOpened(false)
        }}
      />
    </BannerContainer>
  )
}
